import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';
import { map } from 'lodash';
import ConfigurationsConnectors from '../ConfigurationsConnectors';
import Sources from '../../Sources/Sources';
import Connectors from '../../Connectors/Connectors';

import { getSource, getConnectorId } from '../configurations-connectors-operations';
import Videos from '../../Videos/Videos';
import AnnotationTemplates from '../../AnnotationTemplates/AnnotationTemplates';
import { getAnnotationTemplatesCustom } from '../../Videos/video-operations';

Meteor.publish('configurationsConnectors', function configurationsConnectors() {
  return ConfigurationsConnectors.find(
    { owner: this.userId, deleted: { $eq: 'no' } },
    {
      fields: {
        owner: 0,
        createdAt: 0,
        updatedAt: 0,
        deleted: 0
      }
    }
  );
});

Meteor.publish('configurationsConnectors.video', function configurationsConnectors(videoId) {
  check(videoId, String);
  return ConfigurationsConnectors.find(
    { owner: this.userId, deleted: { $eq: 'no' }, videoId },
    {
      fields: {
        owner: 0,
        createdAt: 0,
        updatedAt: 0,
        deleted: 0
      }
    }
  );
});

Meteor.publish('configConnector.sources', function configurationsConnectors(configId) {
  check(configId, String);
  const configCursor = ConfigurationsConnectors.find({
    owner: this.userId,
    deleted: { $eq: 'no' },
    _id: configId
  });

  const sourceCursor = Sources.find({
    owner: this.userId,
    deleted: { $eq: 'no' },
    _id: getSource(ConfigurationsConnectors.findOne({ _id: configId }) || {})
  });
  const connectorCursor = Connectors.find({
    owner: this.userId,
    deleted: { $eq: 'no' },
    _id: getConnectorId(ConfigurationsConnectors.findOne({ _id: configId }) || {})
  });
  return [configCursor, sourceCursor, connectorCursor];
});

Meteor.publish('configConnector.customTemplates.videos', function configurationsConnectors(
  manyVideosId
) {
  check(manyVideosId, [String]);
  const videosCursor = Videos.find({
    owner: this.userId,
    deleted: { $eq: 'no' },
    _id: { $in: manyVideosId }
  });
  const videos = Videos.find({
    owner: this.userId,
    deleted: { $eq: 'no' },
    _id: { $in: manyVideosId }
  }).fetch();
  const templatesCustomId = [];
  map(videos, vid => {
    const customTemplate = getAnnotationTemplatesCustom(vid);
    map(customTemplate, templateId => templatesCustomId.push(templateId));
  });
  const templatesCursor = AnnotationTemplates.find(
    {
      owner: this.userId,
      deleted: { $eq: 'no' },
      _id: {
        $in: templatesCustomId
      }
    },
    {
      fields: {
        owner: 0,
        deleted: 0
      }
    }
  );

  const configurationsCursor = ConfigurationsConnectors.find(
    { owner: this.userId, deleted: { $eq: 'no' }, videoId: { $in: manyVideosId } },
    {
      fields: {
        owner: 0,
        createdAt: 0,
        updatedAt: 0,
        deleted: 0
      }
    }
  );

  const configs = ConfigurationsConnectors.find(
    { owner: this.userId, deleted: { $eq: 'no' }, videoId: { $in: manyVideosId } },
    {
      fields: {
        owner: 0,
        createdAt: 0,
        updatedAt: 0,
        deleted: 0
      }
    }
  ).fetch();
  const sourcesId = map(configs, item => getSource(item || {}));
  const sourceCursor = Sources.find({
    owner: this.userId,
    deleted: { $eq: 'no' },
    _id: {
      $in: sourcesId
    }
  });

  const connectorsId = map(configs, item => getConnectorId(item || {}));
  const connectorCursor = Connectors.find({
    owner: this.userId,
    deleted: { $eq: 'no' },
    _id: {
      $in: connectorsId
    }
  });
  return [configurationsCursor, templatesCursor, videosCursor, sourceCursor, connectorCursor];
});
